import { PropertyService } from '@/http-services/property.service';
import { asyncComputed } from '@vueuse/core';
import { computed } from 'vue';

export function useCellCost(getPropertyId: () => string | undefined | null) {
  const propertyService = new PropertyService();
  const propertyId = computed(getPropertyId);
  const cellularCost = asyncComputed(async () => {
    if (propertyId.value) {
      const pricing = await propertyService.getSubscriptionPricing(propertyId.value);
      return Number((pricing.CELLULAR.calculatedMonthlyCost / 100).toFixed(2));
    }
    return 0;
  }, 0);

  return { cellularCost };
}
